var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("lesson.lesson_no_selling")))]),_c('router-link',{staticClass:"btn btn-add",attrs:{"to":{name: 'my-page/lesson-create'}}},[_vm._v(_vm._s(_vm.$t("lesson.sell")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }